/* Progressive enhancement only. All product information remains readable without JavaScript. */
export function enhanceNonSync(root) {
	root.classList.add('nsp-js');
	const menu = root.querySelector('[data-nsp-menu]'),
		navigation = root.querySelector('.nsp-nav');
	menu?.addEventListener('click', () => {
		const open = menu.getAttribute('aria-expanded') !== 'true';
		menu.setAttribute('aria-expanded', String(open));
		navigation.classList.toggle('is-open', open);
	});
	navigation?.addEventListener('click', (event) => {
		if (event.target.closest('a')) {
			navigation.classList.remove('is-open');
			menu?.setAttribute('aria-expanded', 'false');
		}
	});
	root.querySelector('[data-nsp-print]')?.addEventListener('click', () => window.print());
	const search = root.querySelector('[data-nsp-search]');
	const sections = [...root.querySelectorAll('.nsp-manual > section')];
	const links = [...root.querySelectorAll('.nsp-toc a')];
	function filter() {
		const words = (search?.value || '').trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
		let found = 0;
		for (const section of sections) {
			const text = section.textContent.toLocaleLowerCase();
			const show = words.every((word) => text.includes(word));
			section.hidden = !show;
			if (show) found++;
			const link = links.find((a) => a.hash === '#' + section.id);
			if (link) link.closest('li').hidden = !show;
		}
		const status = root.querySelector('[data-nsp-results]');
		if (status)
			status.textContent = words.length
				? `${found} of ${sections.length} chapters match`
				: `${sections.length} chapters · Search this manual`;
		const empty = root.querySelector('[data-nsp-empty]');
		if (empty) empty.hidden = found > 0;
	}
	search?.addEventListener('input', filter);
	root.querySelector('[data-nsp-clear]')?.addEventListener('click', () => {
		search.value = '';
		filter();
		search.focus();
	});
	function revealHash() {
		const section = sections.find((s) => '#' + s.id === window.location.hash);
		if (section && section.hidden && search) {
			search.value = '';
			filter();
			section.scrollIntoView();
		}
	}
	window.addEventListener('hashchange', revealHash);
	filter();
	revealHash();
	let observer;
	if ('IntersectionObserver' in window && sections.length) {
		observer = new IntersectionObserver(
			(entries) => {
				const entry = entries.find((e) => e.isIntersecting);
				if (entry)
					for (const link of links) {
						if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'true');
						else link.removeAttribute('aria-current');
					}
			},
			{ rootMargin: '-100px 0px -65% 0px' }
		);
		sections.forEach((section) => observer.observe(section));
	}
	for (const pre of root.querySelectorAll('pre[data-nsp-copy]')) {
		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'nsp-copy';
		button.textContent = 'Copy';
		const code = pre.querySelector('code');
		pre.prepend(button);
		button.addEventListener('click', async () => {
			try {
				await navigator.clipboard.writeText(code.textContent);
				button.textContent = 'Copied';
			} catch {
				button.textContent = 'Select text to copy';
			}
			const status = root.querySelector('[data-nsp-copy-status]');
			if (status) status.textContent = button.textContent;
		});
	}
	return () => {
		window.removeEventListener('hashchange', revealHash);
		observer?.disconnect();
	};
}
